const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const designMode = document.documentElement.classList.contains('shopify-design-mode') || Boolean(window.Shopify?.designMode);

function startIntro() {
  if (designMode || reduceMotion) return;

  try {
    if (document.referrer && new URL(document.referrer).origin === window.location.origin) return;
  } catch (error) {
    // A blocked referrer is treated as a new storefront entry.
  }
  const intro = document.createElement('div');
  intro.className = 'zk-intro';
  intro.setAttribute('aria-label', 'ZENKAI deneyimi yükleniyor');
  intro.innerHTML = `
    <div class="zk-intro__scene" aria-hidden="true">
      <span class="zk-intro__moon"></span>
      <svg class="zk-intro__katana" viewBox="0 0 560 170" role="presentation">
        <defs>
          <linearGradient id="zk-blade" x1="0" x2="1">
            <stop offset="0" stop-color="#7a7a80"/>
            <stop offset=".25" stop-color="#ffffff"/>
            <stop offset=".72" stop-color="#d8d9dd"/>
            <stop offset="1" stop-color="#ffffff"/>
          </linearGradient>
        </defs>
        <g class="zk-intro__sword">
          <path class="zk-intro__blade" d="M104 97C226 79 359 58 500 24C518 20 532 25 540 31C399 72 256 103 115 118Z" fill="url(#zk-blade)"/>
          <path class="zk-intro__edge" d="M110 108C253 91 397 60 540 31"/>
          <path class="zk-intro__guard" d="M101 84L111 129"/>
          <path class="zk-intro__handle" d="M104 107L30 121"/>
          <path class="zk-intro__wrap" d="M91 101L94 116M76 104L79 119M61 107L64 122M46 110L49 125"/>
          <circle class="zk-intro__pommel" cx="27" cy="121.5" r="8"/>
        </g>
      </svg>
      <span class="zk-intro__slash"></span>
      <span class="zk-intro__spark zk-intro__spark--one"></span>
      <span class="zk-intro__spark zk-intro__spark--two"></span>
    </div>
    <div class="zk-intro__petals" aria-hidden="true"></div>`;
  document.body.append(intro);
  const petals = intro.querySelector('.zk-intro__petals');
  for (let i = 0; i < 22; i += 1) {
    const petal = document.createElement('i');
    petal.style.setProperty('--x', `${Math.random() * 100}%`);
    petal.style.setProperty('--delay', `${Math.random() * 0.55}s`);
    petal.style.setProperty('--drift', `${-90 + Math.random() * 180}px`);
    petal.style.setProperty('--spin', `${180 + Math.random() * 360}deg`);
    petals.append(petal);
  }
  window.setTimeout(() => intro.classList.add('zk-intro--out'), 2050);
  window.setTimeout(() => intro.remove(), 2600);
}

function setupPageTransitions() {
  if (designMode) return;
  const loader = document.createElement('div');
  loader.className = 'zk-page-loader';
  loader.setAttribute('aria-hidden', 'true');
  loader.innerHTML = '<span class="zk-page-loader__line"></span><span class="zk-page-loader__blade"></span><span class="zk-page-loader__label">Yolculuk devam ediyor</span>';
  document.body.append(loader);

  const hideLoader = () => loader.classList.remove('is-active');
  window.addEventListener('pageshow', hideLoader);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.hasAttribute('download') || link.target === '_blank' || link.closest('[data-no-page-transition]')) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.protocol === 'mailto:' || url.protocol === 'tel:') return;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;
    loader.classList.add('is-active');
  });
}

function setupReveals() {
  if (designMode || reduceMotion || !('IntersectionObserver' in window)) return;
  const targets = document.querySelectorAll('.zk-store-card, .zk-contact__intro, .zk-contact__layout, .zk-storefront__categories');
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('zk-revealed'); observer.unobserve(entry.target); } }), { threshold: 0.12 });
  targets.forEach((target) => { target.classList.add('zk-reveal'); observer.observe(target); });
}

function setupClickFeedback() {
  if (designMode) return;
  document.addEventListener('pointerdown', (event) => {
    const target = event.target.closest('a, button');
    if (!target || reduceMotion) return;
    target.classList.add('zk-tapped');
    window.setTimeout(() => target.classList.remove('zk-tapped'), 180);
  });
}

function setupEditorAccountLink() {
  if (!designMode) return;

  document.addEventListener('click', (event) => {
    const accountLink = event.target.closest('[data-zenkai-account-link]');
    if (!accountLink) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.open(accountLink.href, '_blank', 'noopener,noreferrer');
  }, true);
}

startIntro(); setupReveals(); setupClickFeedback(); setupPageTransitions(); setupEditorAccountLink();
